import { render, staticRenderFns } from "./SerieListModal.vue?vue&type=template&id=987b5bf4&scoped=true"
import script from "./SerieListModal.vue?vue&type=script&lang=js"
export * from "./SerieListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987b5bf4",
  null
  
)

export default component.exports